export default __webpack_public_path__ + "static/media/plain-sticker-ed.80ba1169.png";